export function calculateTimestamp(event){
    let hours = null;
    if(event.hours !== null && event.hours !== ""){
        hours = event.hours.split(",").map(Number);
    }

    let months = null;
    if(event.months !== null && event.months !== ""){
       months = event.months.split(",").map(function(x){return parseInt(x, 10) - 1});
    }
    
    let minutes = null;
    if(event.minutes !== null && event.minutes !== ""){
        minutes = event.minutes.split(",").map(Number);
    }

    let daysOfMonth = null;
    if(event.daysOfMonth !== null && event.daysOfMonth !== ""){
        daysOfMonth = event.daysOfMonth.split(",").map(function(x){return parseInt(x, 10)});
    }

    let daysOfWeek = null;
    if(event.daysOfWeek !== null && event.daysOfWeek !== ""){
        daysOfWeek = event.daysOfWeek.split(",").map(function(x){return parseInt(x, 10) - 1});
    }

    let constructedDate = checkDay(months, daysOfMonth, daysOfWeek, hours, minutes);
    return constructedDate;
}


function checkDay(months, daysOfMonth, daysOfWeek, hours, minutes)
	{
        console.log(months)
        let nextYear = false;
        let date = new Date();
        let currentString = {
            months: date.getMonth(),
            daysOfMonth: date.getDate(),
            hours: date.getHours(),
            minutes: date.getMinutes(),
            daysOfWeek: date.getDay()
        }

        let returner = {};
        
        if(months === null){
            returner.months = currentString.months;
            if(daysOfMonth === null && daysOfWeek === null){ 
                returner.daysOfMonth = currentString.daysOfMonth;
                if(hours === null){//If all hours apply
                    returner.hours = currentString.hours;
                    if(minutes === null){
                        returner.minutes = currentString.minutes;
                    }   
                    else{
                        returner.minutes = getNext(minutes, currentString.minutes);
                        if(returner.minutes < currentString.minutes){
                            returner.minutes = getLowest(minutes, currentString.minutes);
                            if(returner.hours >= 23){returner.hours = 0;}
                            else{returner.hours += 1;}
                        }
                    }
                }
                else{//If there is a set amount of hours
                    returner.hours = getNext(hours, currentString.hours);
                    if(returner.hours < currentString.hours){
                        returner.hours = getLowest(hours, currentString.hours)
                        returner.minutes = getLowest(minutes);
                    }
                    else if(returner.hours === currentString.hours){
                        if(minutes === null){returner.minutes = currentString.minutes;}
                        else{
                            returner.minutes = getNext(minutes, currentString.minutes);
                            if(returner.minutes < currentString.minutes){
                                returner.hours = getNext(hours, (currentString.hours + 1));
                                if(returner.hours <= currentString.hours){
                                    
                                    returner.daysOfMonth += 1;
                                    
                                }
                            }
                        
                        }
                    }
                    else{returner.minutes = getLowest(minutes);}
                }
            }
            else{
                if(daysOfMonth === null){
                    returner.daysOfMonth = getNextDayOfMonth(daysOfWeek, currentString.daysOfWeek, currentString.daysOfMonth);
                    if(returner.daysOfMonth !== currentString.daysOfMonth){
                        if(returner.daysOfMonth < currentString.daysOfMonth){
                            if(returner.months >= 11){
                                returner.months = 0;
                                nextYear = true;
                            }
                            else{
                                returner.months += 1;
                            }
                        }
                        returner.hours = getLowest(hours);
                        returner.minutes = getLowest(minutes);
                    }
                    else{
                        if(hours === null){
                            returner.hours = currentString.hours;
                            if(minutes === null){
                                returner.minutes = currentString.minutes;
                            }   
                            else{
                                returner.minutes = getNext(minutes, currentString.minutes);
                                if(returner.minutes < currentString.minutes){
                                    returner.minutes = getLowest(minutes, currentString.minutes);
                                    if(returner.hours >= 23){
                                        returner.hours = 0;
                                        returner.daysOfMonth =  getNextDayOfMonth(daysOfWeek, currentString.daysOfWeek + 1, currentString.daysOfMonth + 1);
                                        if(returner.daysOfMonth < currentString.daysOfMonth){
                                            if(returner.months >= 11){
                                                returner.months = 0;
                                                nextYear = true;
                                            }
                                            else{
                                                returner.months += 1;
                                            }
                                        }
                                    }
                                    else{returner.hours += 1;}
                                }
                            }
                        }
                        else{
                            returner.hours = getNext(hours, currentString.hours);
                            if(returner.hours < currentString.hours){

                            }
                            else if(returner.hours === currentString.hours){
                                if(minutes === null){
                                    returner.minutes = currentString.minutes;
                                }
                                else{
                                    returner.minutes = getNext(minutes);
                                    if(returner.minutes < currentString.minutes){
                                        returner.hours = getNext(hours, currentString.hours + 1);
                                        if(returner.hours <= currentString.hours){
                                            returner.daysOfMonth = getNextDayOfMonth(daysOfWeek, currentString.daysOfWeek + 1, currentString.daysOfMonth + 1);
                                            if(returner.daysOfMonth < currentString.daysOfMonth){
                                                if(returner.months >= 11){
                                                    returner.months = 0;
                                                    nextYear = true;
                                                }
                                                else{
                                                    returner.months += 1;
                                                }
                                                returner.hours = getLowest(hours);
                                                returner.minutes = getLowest(minutes);
                                            }
                                        }
                                        else{
                                            returner.minutes = getLowest(minutes);
                                        }
                                    }
                                }
                                
                            }
                            else{
                                returner.minutes = getLowest(minutes);
                            }
                        }
                    }
                }
                else{
                    returner.daysOfMonth = getNext(daysOfMonth, currentString.daysOfMonth);
                    if(returner.daysOfMonth !== currentString.daysOfMonth){
                        returner.hours = getLowest(hours);
                        returner.minutes = getLowest(minutes);
                    }
                    else{
                        if(hours === null){
                            returner.hours = currentString.hours;
                            if(minutes === null){
                                returner.hours = currentString.hours;
                            }
                            else{
                                returner.minutes = getNext(minutes, currentString.minutes);
                                if(returner.minutes < currentString.minutes){
                                    if(returner.hours >= 23){
                                        returner.hours = 0;
                                    }
                                    else{
                                        returner.hours += 1;
                                    }
                                }
                            }
                        }
                        else{
                            returner.hours = getNext(hours, currentString.hours);
                            if(returner.hours < currentString.hours){
                                returner.daysOfMonth = getNext(daysOfMonth, (currentString.daysOfMonth + 1))
                                if(returner.daysOfMonth <= currentString.daysOfMonth){
                                    if(returner.months >= 11){
                                        returner.months = 0;
                                        nextYear = true;
                                    }
                                    else{
                                        returner.months += 1;
                                    }
                                }
                                returner.hours = getLowest(hours);
                                returner.minutes = getLowest(minutes);
                            }
                            else if(returner.hours === currentString.hours){
                                if(minutes === null){returner.minutes = currentString.minutes}
                                else{
                                    returner.minutes = getNext(minutes, currentString.minutes);
                                    if(returner.minutes < currentString.minutes){
                                        returner.hours = getNext(hours, (currentString.hours + 1));
                                        if(returner.hours <= currentString.hours){
                                            returner.daysOfMonth = getNext(daysOfMonth, (currentString.daysOfMonth + 1))
                                            if(returner.daysOfMonth <= currentString.daysOfMonth){
                                                if(returner.months >= 11){
                                                    returner.months = 0;
                                                }
                                                else{
                                                    returner.months += 1;
                                                }
                                            }
                                            returner.hours = getLowest(hours);
                                            returner.minutes = getLowest(minutes);
                                        }
                                        else{
                                            minutes = getLowest(minutes);
                                        }
                                    }
                                }
                            }
                            else{
                                minutes = getLowest(minutes);
                            }
                        }
                    }
                }
            }
        }
        else{
            returner.months = getNext(months, currentString.months);

            if(returner.months !== currentString.months){
                if(returner.months < currentString.months){
                    nextYear = true;
                }
                if(daysOfWeek !== null){
                    let tempdate;
                    if(nextYear){
                        tempdate = new Date((date.getFullYear() + 1), returner.months);
                    }
                    else{
                        tempdate = new Date((date.getFullYear()), returner.months)
                    }
                    returner.daysOfMonth = getNextDayOfMonth(daysOfWeek, tempdate.getDay(), tempdate.getDate());
                }
                else{
                    returner.daysOfMonth = getLowest(daysOfMonth, currentString.daysOfMonth);
                }
                returner.hours = getLowest(hours);
                returner.minutes = getLowest(minutes);

            }
            else{
                if(daysOfMonth === null && daysOfWeek === null){
                    returner.daysOfMonth = currentString.daysOfMonth;
                    if(hours === null){//If all hours apply
                        returner.hours = currentString.hours;
                        if(minutes === null){
                            returner.minutes = currentString.minutes;
                        }   
                        else{
                            returner.minutes = getNext(minutes, currentString.minutes);
                            if(returner.minutes < currentString.minutes){
                                returner.minutes = getLowest(minutes, currentString.minutes);
                                if(returner.hours >= 23){returner.hours = 0;}
                                else{returner.hours += 1;}
                            }
                        }
                    }
                    else{//If there is a set amount of hours
                        returner.hours = getNext(hours, currentString.hours);
                        if(returner.hours < currentString.hours){
                            returner.hours = getLowest(hours, currentString.hours)
                            returner.minutes = getLowest(minutes);
                        }
                        else if(returner.hours === currentString.hours){
                            if(minutes === null){returner.minutes = currentString.minutes;}
                            else{
                                returner.minutes = getNext(minutes, currentString.minutes);
                                if(returner.minutes < currentString.minutes){
                                    returner.hours = getNext(hours, (currentString.hours + 1));
                                    if(returner.hours <= currentString.hours){
                                        
                                        returner.daysOfMonth += 1;
                                        
                                    }
                                }
                            
                            }
                        }
                        else{returner.minutes = getLowest(minutes);}
                    }
                }
                else{
                if(daysOfMonth === null){
                    returner.daysOfMonth = getNextDayOfMonth(daysOfWeek, currentString.daysOfWeek, currentString.daysOfMonth);
                    if(returner.daysOfMonth !== currentString.daysOfMonth){
                        if(returner.daysOfMonth < currentString.daysOfMonth){
                            returner.months = getNext(months, currentString.months + 1);
                            if(returner.months < currentString.months){
                                nextYear = true;
                            }
                        }
                        returner.hours = getLowest(hours);
                        returner.minutes = getLowest(minutes);
                    }
                    else{
                        if(hours === null){
                            returner.hours = currentString.hours;
                            if(minutes === null){
                                returner.minutes = currentString.minutes;
                            }
                            else{
                                returner.minutes = getNext(minutes, currentString.minutes);
                                if(returner.minutes < currentString.minutes){
                                    if(returner.hours >= 23){
                                        returner.daysOfMonth = getNextDayOfMonth(daysOfWeek, currentString.daysOfWeek + 1, currentString.daysOfMonth + 1);
                                        if(returner.daysOfMonth < currentString.daysOfMonth){
                                            returner.months = getNext(months, currentString.months + 1);
                                            if(returner.months < currentString.months){
                                                nextYear = true;
                                            }
                                            returner.hours = getLowest(hours);
                                            returner.minutes = getLowest(minutes);
                                        }
                                    }
                                    else{
                                        returner.hours += 1;
                                    }
                                }
                            }
                        }
                        else{
                            returner.hours = getNext(hours, currentString.hours);
                            if(returner.hours < currentString.hours){

                                returner.daysOfMonth = getNextDayOfMonth(daysOfWeek, currentString.daysOfWeek + 1, currentString.daysOfMonth + 1);
                                if(returner.daysOfMonth < currentString.daysOfMonth){
                                    returner.months = getNext(months, currentString.months + 1);
                                    if(returner.months < currentString.months){
                                        nextYear = true;
                                    }
                                    returner.hours = getLowest(hours);
                                    returner.minutes = getLowest(minutes);
                                }
                            }
                            else if(returner.hours > currentString.hours){
                                returner.minutes = getLowest(minutes);
                            }
                            else{
                                if(minutes === null){
                                    returner.minutes = currentString.minutes;
                                }
                                else{
                                    returner.minutes = getNext(minutes, currentString.minutes);
                                    if(returner.minutes < currentString.minutes){
                                        returner.hours = getNext(hours, currentString.hours + 1);
                                        if(returner.hours < currentString.hours){
                                            returner.daysOfMonth = getNextDayOfMonth(daysOfWeek, currentString.daysOfWeek + 1, currentString.daysOfMonth + 1);
                                            if(returner.daysOfMonth < currentString.daysOfMonth){
                                                returner.months = getNext(months, currentString.months + 1);
                                                if(returner.months < currentString.months){
                                                    nextYear = true;
                                                }
                                                returner.hours = getLowest(hours);
                                                returner.minutes = getLowest(minutes);
                                            }
                                        }
                                        else{returner.minutes = getLowest(minutes);}
                                    }
                                    else if(returner.minutes === currentString.minutes){
                                        returner.minutes = getNext(minutes, currentString.minutes);
                                    }
                                    else{
                                        returner.minutes = getLowest(minutes);
                                    }
                                }
                            }
                        }
                    }
                }
                else{
                    returner.daysOfMonth = getNext(daysOfMonth, currentString.daysOfMonth);
                    if(returner.daysOfMonth !== currentString.daysOfMonth){
                        if(returner.daysOfMonth < currentString.daysOfMonth){
                            returner.months = getNext(months, (currentString.months + 1));
                            if(returner.months <= currentString.months){nextYear = true}
                        }
                        returner.hours = getLowest(hours);
                        returner.minutes = getLowest(minutes);
                    }
                    else{
                        if(hours === null){
                            returner.hours = currentString.hours;
                            if(minutes === null){
                                returner.hours = currentString.hours;
                            }
                            else{
                                returner.minutes = getNext(minutes, currentString.minutes);
                                if(returner.minutes < currentString.minutes){
                                    if(returner.hours >= 23){
                                        returner.hours = 0;
                                    }
                                    else{
                                        returner.hours += 1;
                                    }
                                }
                            }
                        }
                        else{
                            returner.hours = getNext(hours, currentString.hours);
                            if(returner.hours < currentString.hours){
                                returner.daysOfMonth = getNext(daysOfMonth, (currentString.daysOfMonth + 1))
                                if(returner.daysOfMonth <= currentString.daysOfMonth){
                                    if(returner.months >= 11){
                                        returner.months = 0;
                                        nextYear = true;
                                    }
                                    else{
                                        returner.months += 1;
                                    }
                                }
                                returner.hours = getLowest(hours);
                                returner.minutes = getLowest(minutes);
                            }
                            else if(returner.hours === currentString.hours){
                                if(minutes === null){returner.minutes = currentString.minutes}
                                else{
                                    returner.minutes = getNext(minutes, currentString.minutes);
                                    if(returner.minutes < currentString.minutes){
                                        returner.hours = getNext(hours, (currentString.hours + 1));
                                        if(returner.hours <= currentString.hours){
                                            returner.daysOfMonth = getNext(daysOfMonth, (currentString.daysOfMonth + 1))
                                            if(returner.daysOfMonth <= currentString.daysOfMonth){
                                                if(returner.daysOfMonth <= currentString.daysOfMonth){
                                                    returner.months = getNext(months, currentString.months);
        
                                                    if(returner.months <= currentString.months){
                                                        nextYear = true;
                                                    }
                                                }
                                            }
                                            returner.hours = getLowest(hours);
                                            returner.minutes = getLowest(minutes);
                                        }
                                        else{
                                            minutes = getLowest(minutes);
                                        }
                                    }
                                }
                            }
                            else if(returner.hours > currentString.hours){
                                returner.minutes = getLowest(minutes);
                            }
                        }
                    }
                    }
                }
            }
                }
                
        if(nextYear){
            returner.year = date.getFullYear() + 1;
        }
        else{
            returner.year = date.getFullYear();
        }
        console.log(months);
        return processDate(returner);
        

}

function processDate(dateObject){
    let tempDate = new Date(dateObject.year, (dateObject.months + 1), 0);
    console.log(dateObject.daysOfMonth +" : " + tempDate.getDate());
    if(tempDate.getDate() < dateObject.daysOfMonth){
        dateObject.daysOfMonth = tempDate.getDate();
    }
    let finalDate = new Date(dateObject.year, dateObject.months, dateObject.daysOfMonth, dateObject.hours, dateObject.minutes);
    return Date.parse(finalDate);
    
}

function getLowest(unitArray){
    if(unitArray === null){
        return 0;
    }
    return unitArray.sort(function(a, b){return a - b})[0]
}
function getNext(unitArray, date){

    unitArray.sort(function(a, b){return a - b});


    for(let index in unitArray){
        if(unitArray[index] >= date){
            return unitArray[index];
        }
    }
    return unitArray[0];
    
}       
function  getNextDayOfMonth(daysOfWeek, currentDaysOfWeek, currentDaysOfMonth){
    let tempWeekDay = getNext(daysOfWeek, currentDaysOfWeek);
    let dayModifier = 0;
    if(tempWeekDay < currentDaysOfWeek){
        dayModifier = 7 - (currentDaysOfWeek - tempWeekDay);
    }
    else if(tempWeekDay === currentDaysOfWeek){
        return currentDaysOfMonth;
    }
    else{
        dayModifier = tempWeekDay - currentDaysOfWeek;
    }
    currentDaysOfMonth = currentDaysOfMonth + dayModifier;
    
    return currentDaysOfMonth;
}



// WEBPACK FOOTER //
// ./src/utils/timestamp.js